import { render } from "./ModalInfoCaminhao.vue?vue&type=template&id=1f0a069a&scoped=true&ts=true"
import script from "./ModalInfoCaminhao.vue?vue&type=script&lang=ts"
export * from "./ModalInfoCaminhao.vue?vue&type=script&lang=ts"

import "./ModalInfoCaminhao.vue?vue&type=style&index=0&id=1f0a069a&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0a069a"]])

export default __exports__